<template>
    <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: stretch">
        <div style="flex-grow: 0; height: auto; padding: 10px; display: flex;">
            <v-spacer></v-spacer>
            <agent-version-deploy-button :selected="selected">
            </agent-version-deploy-button>
        </div>
        <div style="flex-grow: 1; height: 100%;">
            <vue-data-table
                    ref="dataTable"
                    v-model="selected"
                    :headers="headers"
                    :items="itemsMapped"
                    item-key="raw.countryCode"
                    show-select
            ></vue-data-table>
        </div>
    </div>
</template>

<script>
    import VueDataTable from "@/assets/plugins/vue-data-table/VueDataTable";
    import {PATH} from "@/constants";
    import AgentVersionDeployButton from "@/views/monitoring/part/AgentVersionDeployButton";
    import AgentDeployVersion from "@/model/agent-deploy-version";

    export default {
        name: "MonitoringAgentDeployByCountry",
        components: {AgentVersionDeployButton, VueDataTable},
        data() {
            return {
                selected: [],
                items: [],
                headers: [
                    {
                        text: "국가",
                        value: "raw.countryName",
                        width: 300,
                    },
                    {
                        text: "PC Agent version",
                        value: "raw.pcVer",
                        width: 500,
                    },
                    {
                        text: "Tnbox Agent version",
                        value: "raw.dvVer",
                        width: 500,
                    },
                ],
                searchOptions: {},
            }
        },
        computed: {
            itemsComputed() {
                const obj = {};

                this.items.forEach(e => {
                    const key = e.countryCode ? e.countryCode.toUpperCase() : "null";
                    // 해당 국가에 대한 오브젝트를 생성합니다.
                    if (!obj[key]) {
                        obj[key] = {};
                        obj[key].countryName = e.countryName;
                        obj[key].countryCode = e.countryCode;
                    }

                    // 해당 국가에 대한 PC, DV 버전의 Min Version - Max Version 문자열을 저장합니다.
                    if (e.codeKey.toUpperCase() === "PC") {
                        obj[key].pcVer = e.minVer + " - " + e.maxVer;
                    } else if (e.codeKey.toUpperCase() === "DV") {
                        obj[key].dvVer = e.minVer + " - " + e.maxVer;
                    }
                });

                let arr = [];
                Object.keys(obj).forEach(key =>
                    arr.push({
                        countryName: obj[key].countryName,
                        countryCode: obj[key].countryCode,
                        pcVer: obj[key].pcVer,
                        dvVer: obj[key].dvVer,
                    })
                );

                return arr;
            },

            itemsMapped() {
                return this.itemsComputed.map(e => new AgentDeployVersion(e, "country"));
            },
        },
        created() {
            this.load();
        },
        methods: {
            async load() {
                const res = await this.$request(PATH.MONITORING.AGENT_VERSION_BY_COUNTRY)
                    .setObject({
                        ...this.searchOptions,
                    })
                    .catch()
                    .enqueue();
                this.items = res.data;
            },
        },
    }
</script>

<style scoped>

</style>